// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-7238a160]{outline:1px solid #fff}.box[data-v-7238a160]:hover{border:1px solid #63da2a;outline:1px solid #63da2a}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
